import React from "react";

import { SectionIds } from "@constants/sectionIds";

import useProductFeaturesData from "./useProductFeaturesData";
import ProductFeatureCard from "./ProductFeatureCard/ProductFeatureCard";

import "./ProductFeatures.scss";

const ProductFeatures = () => {
  const data = useProductFeaturesData();

  return (
    <section id={SectionIds.ProductFeatures} className="product-features">
      {data.map(({ img, title, description }, index) => (
        <ProductFeatureCard key={index} imgSrc={img.src} imgAlt={img.alt} title={title} description={description} />
      ))}
    </section>
  );
};

export default ProductFeatures;
